const CinemaHallData = [
  {
    name: "Cinepolis P&M Mall, Patna",
    showTime: ["09:00 AM", "11:00 AM", "02:25 PM", "03:50 PM", "10:40 PM"],
    price: 250,
  },
  {
    name: "Carnival Cinemas, Patna",
    showTime: ["09:30 AM", "01:30 PM", "04:20 PM", "07:10 PM", "10:00 PM"],
    price: 250,
  },
  {
    name: "Krishna Talkies, Patna",
    showTime: ["09:30 AM", "01:30 PM", "04:20 PM", "07:10 PM", "10:00 PM"],
    price: 250,
  },
  {
    name: "Connplex Smart Theater, Patna",
    showTime: ["09:30 AM", "01:30 PM", "04:20 PM", "07:10 PM", "10:00 PM"],
    price: 250,
  },
];

export default CinemaHallData;
